import { copyApiPrefilterPerRole } from "@shared/backend/entity-security/copy-api-prefilter-per-role";
import { doesExist } from "@shared/backend/entity-security/does-exist";
import type { HyperEntityConfig } from "@shared/backend/hyper-entity.decorator";
import { Roles } from "@shared/Roles";
import { Allow, remult } from "remult";
import { Association } from "../association";
import { Community } from "../community/entity";
import { type CommunityAssociation } from "./entity";

export const CommunityAssociationEntityConfig: HyperEntityConfig<CommunityAssociation> =
  {
    allowApiRead: Allow.authenticated,
    allowApiCrud: [Roles.Admin, Roles.SuperAdmin, Roles.Manager, Roles.User],
    apiPrefilterPerRole: async (filter) => {
      filter(Roles.All, {
        community: {
          $is: await copyApiPrefilterPerRole(Community),
        },
      });

      filter(Roles.All, {
        association: {
          $is: await copyApiPrefilterPerRole(Association),
        },
      });
    },

    allowInsertPerRole(allow) {
      allow(Roles.User, (entity) =>
        remult.user!.associations!.includes(entity.associationId),
      );

      allow(Roles.OrganizationManagers, (entity) =>
        doesExist(Community, {
          id: entity.communityId,
          organization: {
            $id: remult.user!.organizationId!,
          },
        }),
      );
    },

    allowDeleteAndUpdatePerRole(allow) {
      allow(Roles.User, (entity) =>
        remult.user!.associations!.includes(entity.associationId),
      );

      allow(Roles.OrganizationManagers, {
        community: {
          $is: {
            organization: {
              $id: remult.user!.organizationId!,
            },
          },
        },
      });
    },

    id: {
      communityId: true,
      associationId: true,
    },
  };
